import React from "react";
import "./style.scss";
import "./style-rtl.scss";
import { parseFeatureValueList } from "../helperFunctions";
import { useTranslation } from "react-i18next";

function fileExtensionFromValue(value) {
    if (!value || typeof value !== "string") return "bin";
    const mime = value.split(";")[0]?.split("/")[1];
    if (mime === "x-zip-compressed") return "zip";
    return mime || "bin";
}

function openFeatureFile(value) {
    if (!value) return;
    window.open(value, "_blank", "noopener,noreferrer");
}

export default function Card({ name, value, type, isFixed }) {
    const { t } = useTranslation();

    return (
        <div
            className={`product-card${
                type === 2 && isFixed ? " product-card--file-fixed" : ""
            }`}
            onClick={
                type === 2 && isFixed
                    ? () => openFeatureFile(value)
                    : undefined
            }
            role={type === 2 && isFixed ? "button" : undefined}
            tabIndex={type === 2 && isFixed ? 0 : undefined}
            onKeyDown={
                type === 2 && isFixed
                    ? (e) => {
                          if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              openFeatureFile(value);
                          }
                      }
                    : undefined
            }
        >
            <div className="product-card__name">{name}</div>
            <div className="product-card__value">
                {(type === 1 || type === 3 || type === 4) && value}
                {type === 2 &&
                    (isFixed ? (
                        <button
                            type="button"
                            className="product-card__view-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                openFeatureFile(value);
                            }}
                        >
                            {t("feature.file.view")}
                        </button>
                    ) : (
                        <a
                            href={value}
                            target="_blank"
                            rel="noopener noreferrer"
                            download={`file.${fileExtensionFromValue(value)}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {t("feature.link.default", {
                                defaultValue: "کلیک کنید",
                            })}
                        </a>
                    ))}
                {type === 5 && (
                    <div className="feature-tag-card">
                        {parseFeatureValueList(value).map((item, index) => (
                            <div key={index}>{item}</div>
                        ))}
                    </div>
                )}
                {type === 6 && (
                    <div dangerouslySetInnerHTML={{ __html: value }}></div>
                )}
            </div>
        </div>
    );
}
